import { Form } from 'antd';
import { useContext } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { EmojiSelector } from 'app/components/commons/EmojiSelector/EmojiSelector';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useEmojis } from 'app/hooks/data/useEmojis';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import type { Picture } from 'app/typings';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import { CoverPicture } from './_components/CoverPicture';
import { Photos } from './_components/Photos';
import {
  pictureToPictureView,
  pictureViewToPicture,
} from './_components/utils';

export const Medias = () => {
  const { mode } = useContext(ViewEditModeContext);
  const { data: experienceCategories } = useExperiencesCategories();
  const { data: emojis } = useEmojis();

  const form = Form.useFormInstance();
  const emoji = Form.useWatch('emoji', form);
  const categoryIdValue = Form.useWatch('categoryId', form);

  const experienceCategory = experienceCategories?.find(
    (category) => category.id === categoryIdValue
  );

  return (
    <>
      <SCard title="Cover Picture">
        <FormLineLayout label="Cover picture" isRequired labelOnTop>
          <CoverPicture />
        </FormLineLayout>
      </SCard>
      <SCard
        title="Pictures"
        subtitle="Define the pictures that will appear in the activity carousel"
      >
        <FormLineLayout label="Carousel pictures" labelOnTop>
          <Photos />
        </FormLineLayout>
      </SCard>
      <SCard
        title="Emoji"
        subtitle="Define the emoji that will appear if the activity is set as add-on"
      >
        <FormLineLayout label="Emoji" isRequired>
          <Form.Item
            name="emoji"
            initialValue={emojis?.find(
              (e) => e.id === experienceCategory?.pictureId
            )}
            getValueProps={(value: PictureView) => ({
              emoji: value ? pictureViewToPicture(value) : undefined,
            })}
            getValueFromEvent={(picture: Picture) =>
              picture ? pictureToPictureView(picture) : undefined
            }
          >
            <EmojiSelector
              mode={mode}
              value={emoji ? pictureViewToPicture(emoji) : undefined}
            />
          </Form.Item>
        </FormLineLayout>
      </SCard>
    </>
  );
};
